import { isLength } from 'validator';

export function minLength(length) {
  return fieldName => (value = '') =>
    isLength(value || '', { min: length })
      ? undefined
      : `${fieldName} must be at least ${length} characters long`;
}
